const nextSeoConfig = {
  community_lab: {
    titleTemplate: '%s | Community Lab',
    title: 'Community Lab',
    description:
      'Community Lab is an innovation and collaboration platform for positive impact. Through our digital platform, you can share ideas, discover challenges and contribute.',
    openGraph: {
      url: 'https://communitylab.app/',
      site_name: 'Community Lab',
      description:
        'Community Lab is an innovation and collaboration platform for positive impact. Through our digital platform, you can share ideas, discover challenges and contribute.',
    },
    altText: 'Community Lab - Where innovation happens',
    twitter: {
      handle: '@CommunityLabApp',
      site: '@CommunityLabApp',
      cardType: 'summary_large_image',
    },
  },
  space_network: {
    titleTemplate: '%s | Space Network',
    title: 'Space Network',
    description:
      'Space Network is a platform for creating and managing communities.',
    openGraph: {
      url: 'https://space.network/',
      site_name: 'Space Network',
      description:
        'Space Network is a platform for creating and managing communities.',
    },
    altText: 'Space Network - Where communities connect',
    twitter: {
      handle: '@SpaceNetwork',
      site: '@SpaceNetwork',
      cardType: 'summary_large_image',
    },
  },
}

const getInstanceConfig = require('./instanceConfigSelector')

module.exports = getInstanceConfig(nextSeoConfig)
